import React from 'react';
import PageTitleImg from "../../assets/images/Banner_Title.jpg";
import { config } from '../pages/config';
import { Link } from 'react-router-dom';

const Bredcrum = ({ heading, path = [], variant }) => {
    const isHighlighted = variant === 'highlighted';

    return (
        <section className={`page-title${isHighlighted ? ' page-title-highlighted' : ''}`}>
            {!isHighlighted && (
                <div
                    className="bg-layer"
                    style={{ backgroundImage: `url(${PageTitleImg})` , backgroundPosition:"top center" }}
                />
            )}
            <div className="auto-container">
                <div className="content-box">
                    {!isHighlighted && <h1>{heading}</h1>}
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to={`${config.appUrl}`}>Home</Link>
                        </li>
                        {
                            path.map((item, index) => {
                                // Construct the full path for each breadcrumb segment
                                const fullPath = `${config.appUrl}${item.path}`;

                                return (
                                    <React.Fragment key={index}>
                                        {/* Show the separator for all but the first breadcrumb */}
                                        <li><i className='bi bi-chevron-right'></i></li>
                                        <li><Link to={fullPath}>{item.name}</Link></li>
                                    </React.Fragment>
                                );
                            })
                        }
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default Bredcrum;
